module.exports = __webpack_public_path__ + "img/huawei1.bbb84513.png";